import { render, staticRenderFns } from "./screent_right.vue?vue&type=template&id=8869fb20&scoped=true"
import script from "./screent_right.vue?vue&type=script&lang=js"
export * from "./screent_right.vue?vue&type=script&lang=js"
import style0 from "./screent_right.vue?vue&type=style&index=0&id=8869fb20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8869fb20",
  null
  
)

export default component.exports